import React from "react";
import { Instagram, Linkedin, Facebook, MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="47981" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((item, i) => <div key={i} data-index={i} className="h-4 w-24 bg-white/10 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-primary-foreground/70 hover:text-secondary transition-colors text-sm" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function MainFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="village-footers" className="dark bg-primary text-primary-foreground py-16 border-t border-white/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606399/img/village_seafood_logo_white.png" alt="Village Seafood Logo" className="h-9 w-auto object-contain" />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed max-w-xs">
              Village Seafood brings the ocean's finest harvest directly to your doorstep in The Villages, ensuring peak freshness through our specialized cold-chain delivery.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-xl font-medium tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="23" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-xl font-medium tracking-tight">Local Service</h3>
            <div className="flex flex-col gap-4 text-sm text-primary-foreground/70">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-secondary" />
                <span>Serving the exclusive communities of The Villages, FL</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 shrink-0 text-secondary" />
                <Link to="tel:+13525550123" className="hover:text-secondary transition-colors">
                  (352) 555-0123
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0 text-secondary" />
                <Link to="mailto:fresh@villageseafood.com" className="hover:text-secondary transition-colors">
                  fresh@villageseafood.com
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-1 shrink-0 text-secondary" />
                <span>Mon-Sat: 9am - 5pm<br />Delivery: 10am - 4pm</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-xl font-medium tracking-tight">Stay Connected</h3>
            <div className="flex items-center gap-4">
              <Link to="https://instagram.com" newTab className="bg-white/10 backdrop-blur-sm p-3 rounded-xl hover:bg-white/20 hover:text-secondary transition-all text-primary-foreground/80" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
              <Link to="https://linkedin.com" newTab className="bg-white/10 backdrop-blur-sm p-3 rounded-xl hover:bg-white/20 hover:text-secondary transition-all text-primary-foreground/80" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </Link>
              <Link to="https://facebook.com" newTab className="bg-white/10 backdrop-blur-sm p-3 rounded-xl hover:bg-white/20 hover:text-secondary transition-all text-primary-foreground/80" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-primary-foreground/50">
          <p>&copy; {currentYear} Village Seafood. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-secondary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-secondary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}